'use strict';
var trackingUtils = require('../modules/utils/tracking.utils');
var fieldUtils = require('../modules/utils/field.utils');
Odigeo.defineWidget('invoice_manager', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        requiredFields: [],

        init: function() {
            this.set({professional: 'B2B'}, {validate: true});
            this.widget.options = Odigeo.parseOptions(this.widget.options);
        },

        validate: function() {
            var fields = this.requiredFields;
            var errors = [];
            var errorType;
            var validity;
            Odigeo._.each(fields, Odigeo._.bind(function(iter) {
                if (iter === 'invoiceId' &&
                    this.widget.options.requiredFieldsPersonal.indexOf('id') === -1 &&
                    this.get('professional') === 'B2C') {
                    return;
                }
                validity = this.checkValidity(iter);
                if (validity === 'empty' || validity === false) {
                    errorType = !validity ? 'invalid' : 'empty';
                    errors.push({name: iter, errorType: errorType});
                }
            }, this));
            return errors.length > 0 ? errors : false;
        },

        checkValidity: function(input) {
            var $input = this.widget.view.$widget.find('[data-name="' + input + '"]');
            $input.val(Odigeo.Utils.trim($input.val()));
            var value = $input.val();
            var regexCheckValue = function(value, valData) {
                return new RegExp(valData.pattern).test(value);
            };
            var validationTypes = {
                REGEX_VALIDATOR: regexCheckValue,
                NULL_VALIDATOR: function(value) {
                    return !!value;
                },
                REQUIRED_STRING: function(value) {
                    return Odigeo._.isString(value) && !!value;
                },
                CIF_NIF_VALIDATOR: Odigeo._.bind(function(value) {
                    return Odigeo.Utils.isValidNif(value) || Odigeo.Utils.isValidCif(value);
                }, this),
                ZIP_CODE_VALIDATOR: regexCheckValue,
            };
            var validation = validationTypes[$input.data('validation-type')] ?
                validationTypes[$input.data('validation-type')](value, $input.data()) : value;
            return Odigeo._.isEmpty(value) ? 'empty' : validation;
        },
    }),
    viewClass: Odigeo.View.extend({
        selectors: {
            invoiceManagerNotNecessary: '.invoicemanager_not_necessary',
            invoiceManagerCollapsibleContent: '.invoicemanager_collapsible_content',
            invoiceManagerFormWrapper: '.invoicemanager_form_wrapper',
            invoiceNameManagerB2B: '.invoicemanager_name_B2B',
            invoiceNameManagerB2C: '.invoicemanager_name_B2C',
            invoiceIdManagerB2B: '.invoicemanager_id_B2B',
            invoiceIdManagerB2C: '.invoicemanager_id_B2C',
            validationField: '.validation_field',
            clearInput: '.clear_input',
            invoiceDisplayOn: '#invoiceDisplayCheck',
            invoiceManagerOption: '[name="invoicemanager_option"]',
            invoiceName: '[name="invoiceName"]',
            invoiceAddress: '[data-name="invoiceAddress"]',
            invoiceCity: '[data-name="invoiceCity"]',
            invoiceZipcode: '[data-name="invoiceZipcode"]',
            invoiceCountryCode: '[data-name="invoiceCountryCode"]',
            invoiceId: '[data-name="invoiceId"]',
            allFocused: '.submit_field_focusable',
            invoiceIdField: '.invoice_id',
            invoiceIdCountry: '.invoice_id .form_field_hover_tag',
            prismaInputs: '.prisma-input',
        },

        inputLabelCorrespondences: {
            invoiceName: 'invoice_name',
            invoiceId: 'invoice_id',
            invoiceZipcode: 'invoice_zipcode',
            invoiceAddress: 'invoice_address',
            invoiceCity: 'invoice_city',
        },

        init: function() {
            this.widget.options = Odigeo.parseOptions(this.widget.options);
            this.$cachedSelectors.invoiceManagerCollapsibleContent = Odigeo.UIElements.collapsive.enhance(
                this.$cachedSelectors.invoiceManagerCollapsibleContent, {
                    triggerLauncher: 'invoiceManagerCollapsible',
                    triggerEvents: true,
                });
            if (this.$cachedSelectors.invoiceManagerCollapsibleContent.length) {
                this.$cachedSelectors.invoiceManagerCollapsibleContent.trigger('collapsePanel');
                this.defineRequiredFields();
                this.bindToDom();
                this.preFillInputsValues();
                this.setCorrectLabels();
            }
        },

        bindToDom: function() {
            this.$cachedSelectors.invoiceDisplayOn.on(Odigeo.Events.change, Odigeo._.bind(Odigeo._.throttle(this.radioChangeHandler, 500), this));

            this.$cachedSelectors.invoiceManagerOption.on(Odigeo.Events.change, Odigeo._.bind(function(e) {
                this.changeTypeOfClient($(e.target).val());
            }, this));

            this.$cachedSelectors.allFocused
                .on(Odigeo.Events.blur, Odigeo._.bind(this._checkField, this, false))
                .on(Odigeo.Events.focus, Odigeo._.bind(this._toggleFocused, this, true));

            if (Odigeo.AB.isCobaltDesktopForms) {
                this.$cachedSelectors.prismaInputs
                    .on(Odigeo.Events.blur, Odigeo._.bind(this._checkField, this, false))
                    .on(Odigeo.Events.focus, Odigeo._.bind(this._toggleFocused, this, true));
            }

            this.$cachedSelectors.clearInput.on(Odigeo.Events.tap, Odigeo._.partial(fieldUtils.clearField, _));

            this.$cachedSelectors.invoiceCountryCode.on(Odigeo.Events.change, Odigeo._.bind(this.createInvoiceIdCountry, this));
            this.createInvoiceIdCountry();
            this.showNotNecessaryMessageWithScroll();
        },

        isIDCountryNeeded: function() {
            return Odigeo._.includes(this.widget.options.countriesWithCodeInId, this.$cachedSelectors.invoiceCountryCode.val()) &&
                    this.widget.model.attributes.professional === 'B2B';
        },
        getCountryValidation: function(countryCode) {
            var countryValidation = this.widget.options.invoiceCountryValidations[countryCode];
            return countryValidation ? countryValidation : this.widget.options.invoiceCountryValidations['default'];
        },
        createInvoiceIdCountry: function() {
            var countryCode = this.getEUCountryCode();
            var countryValidation = this.getCountryValidation(countryCode);
            var needsIdCountry = this.isIDCountryNeeded();

            this.$cachedSelectors.invoiceId
                .data('pattern', countryValidation.regex.pattern)
                .data('validation-type', countryValidation.name)
                .toggleClass('active', needsIdCountry)
                .closest('.validation_field')
                .toggleClass('focused', needsIdCountry);

            this.showInvoiceIdCountry(needsIdCountry);

            if (this.$cachedSelectors.invoiceId.val() !== '') {
                this._checkField(false, this.$cachedSelectors.invoiceId);
            }
        },

        addInvoiceIdCountry: function(attributes) {
            if (this.isIDCountryNeeded()) {
                attributes.invoiceId = this.getEUCountryCode() + attributes.invoiceId;
            }
        },
        showInvoiceIdCountry: function(show) {
            var countryCode = this.getEUCountryCode();
            this.$cachedSelectors.invoiceIdCountry.toggleClass('active', show).html(show ? countryCode : '');
        },

        getEUCountryCode: function() {
            var countryCode = this.$cachedSelectors.invoiceCountryCode.val();
            return countryCode === 'GR' ? 'EL' : countryCode;
        },

        showNotNecessaryMessageWithScroll: function() {
            var lastScrollTop = 0;
            $(window).scroll(Odigeo._.bind(function(e) {
                var aTop = this.$widget.offset().top - this.$widget.height() - 100;
                var aBottom = aTop + 20;
                var scrollTop = $(e.target).scrollTop();

                if (scrollTop >= aTop && scrollTop <= aBottom && lastScrollTop < scrollTop &&
                    this.$cachedSelectors.invoiceManagerNotNecessary.hasClass('show')) {
                    this.$cachedSelectors.invoiceManagerNotNecessary.addClass('animate').removeClass('show');
                }
                lastScrollTop = scrollTop;
            }, this));
        },

        setCorrectLabels: function() {
            var alternativeInputs = ['id', 'name'];
            var selectedInvoice = this.$cachedSelectors.invoiceManagerFormWrapper.attr('data-show');
            var alternativeLabels = this.widget.options.alternativeInvoiceLabels;

            Odigeo._.each(alternativeInputs, Odigeo._.bind(function(input) {
                var inputName = 'invoice' + Odigeo.Utils.capitalize(input);
                var $actualField = this.$cachedSelectors[inputName].closest(this.$cachedSelectors.validationField);
                var actualLabel = alternativeLabels[selectedInvoice][input];
                var errorMandatory = actualLabel.mandatory;

                $actualField.find('.label_field_text').html(actualLabel.label);
                $actualField.find('.wrong_label').html(errorMandatory);

                this.setPlaceholderOrLabel(inputName, actualLabel.label);
                this.$cachedSelectors[inputName]
                    .attr('data-mandatory', errorMandatory)
                    .attr('data-error', actualLabel.error);
            }, this));
        },

        setPlaceholderOrLabel: function(inputName, text) {
            this.$cachedSelectors[inputName].closest('.validation_field')
                .find('.new_label_field').html(text);
        },

        defineRequiredFields: function() {
            var requiredFields = this.widget.options.requiredFieldsPersonal;
            if (!Odigeo._.isEmpty(requiredFields)) {
                if (this.$cachedSelectors.invoiceManagerFormWrapper.attr('data-show') === 'B2B') {
                    requiredFields = this.widget.options.requiredFieldsProfessional;
                }
                this.model.requiredFields = [];
                Odigeo._.each(requiredFields.split(','), function(iter) {
                    var name = 'invoice' + Odigeo.Utils.capitalize(Odigeo.Utils.stringToCamelCase(iter));
                    if (this.$cachedSelectors[name]) {
                        this.model.requiredFields.push(name);
                    }
                }, this);
            }
        },

        radioChangeHandler: function() {
            this.cleanErrors();
            if (this.$cachedSelectors.invoiceDisplayOn.is(':checked')) {
                this.model.set('invoiceRequired', true);
                trackingUtils.trackEvent('invoice_widget', 'open_invoice_clicks');
            }
            this.$cachedSelectors.invoiceManagerCollapsibleContent.trigger('togglePanel');
        },

        getCompleteName: function(user) {
            var lastName = user.lastName ? user.lastName :
                ((user.firstLastName ? ' ' + user.firstLastName : '') +
                (user.secondLastName ? ' ' + user.secondLastName : ''));
            return (user.name || '') + lastName;
        },

        fillAddressFields: function(address, invoiceMap) {
            Odigeo._.each(invoiceMap, Odigeo._.bind(function(value, key) {
                var validationField = this.$cachedSelectors[key].closest('.validation_field');
                this.$cachedSelectors[key].val(address[value] ?
                    address[value] : this.$cachedSelectors[key].val()
                );
                validationField.attr('data-state', 'valid');
            }, this));
        },

        preFillLoggedUser: function(traveller) {
            const invoiceBuyerSessionStorageMap = {
                invoiceAddress: 'address',
                invoiceCity: 'city',
                invoiceZipcode: 'postalCode',
                invoiceCountryCode: 'country',
            };

            if (Odigeo._.isObject(traveller)) {
                traveller.profile.address && this.fillAddressFields(traveller.profile.address, invoiceBuyerSessionStorageMap);
                this.$cachedSelectors.invoiceName.attr('data-prefill-b2c', this.getCompleteName(traveller.profile));
                this.createInvoiceIdCountry();
            }
        },

        preFillInputsValues: function() {
            var passengersData = Odigeo.Utils.parseJson(Odigeo.Session.get('passengersData'));
            var invoiceBuyerSessionStorageMap = {
                invoiceAddress: 'address',
                invoiceCity: 'cityName',
                invoiceZipcode: 'zipCode',
                invoiceCountryCode: 'country',
            };

            if (Odigeo._.isObject(passengersData) && Odigeo._.isObject(passengersData.buyer) && Odigeo._.isObject(passengersData.passengers0)) {
                this.fillAddressFields(passengersData.buyer, invoiceBuyerSessionStorageMap);
                this.$cachedSelectors.invoiceName.attr('data-prefill-b2c', this.getCompleteName(passengersData.passengers0));
                this.createInvoiceIdCountry();
            }
        },

        fillInputName: function(typeOfClientOn) {
            var oldField = 'data-prefill-b2c';
            var newField = 'data-prefill-b2b';
            var value = this.$cachedSelectors.invoiceName.val();

            if (typeOfClientOn === 'B2C') {
                oldField = 'data-prefill-b2b';
                newField = 'data-prefill-b2c';
            }
            if (this.$cachedSelectors.invoiceName.attr(newField)) {
                this.$cachedSelectors.invoiceName.attr(oldField, value)
                    .val(this.$cachedSelectors.invoiceName.attr(newField)).trigger(Odigeo.Events.blur);
            }
        },

        changeTypeOfClient: function(typeOfClientOn) {
            this.model.set('professional', typeOfClientOn);
            this.$cachedSelectors.invoiceManagerFormWrapper.removeClass('od-show').addClass('od-hide');

            Odigeo._.delay(Odigeo._.bind(function() {
                this.cleanErrors();
                this.$cachedSelectors.invoiceManagerFormWrapper.attr('data-show', typeOfClientOn);
                this.$cachedSelectors.validationField.filter('[data-client]').attr('data-client', typeOfClientOn);
                this.fillInputName(typeOfClientOn);
                this.$cachedSelectors.invoiceManagerFormWrapper.removeClass('od-hide').addClass('od-show');
                if (this.widget.options.requiredFieldsPersonal.indexOf('id') === -1) {
                    this.$cachedSelectors.invoiceIdField.toggleClass('hidden', typeOfClientOn === 'B2C');
                    if (Odigeo.AB.isCobaltDesktopForms) {
                        this.$cachedSelectors.invoiceIdField.parents('.invoce_id_field').toggleClass('odf-hidden', typeOfClientOn === 'B2C');
                    }
                } else {
                    this.showInvoiceIdCountry(typeOfClientOn === 'B2B');
                }
                this.setCorrectLabels();
            }, this), 450);
        },

        storageInvoice: function(displayError) {
            var attribs = this.model.getAll();
            this.cleanErrors();
            Odigeo._.each(this.model.requiredFields, Odigeo._.bind(function(iter) {
                attribs[iter] = this.$cachedSelectors[iter].val();
            }, this));
            this.model.set(attribs, {validate: true});
            var isEmpty = Odigeo._.isEmpty(this.model.validationError);
            if (!isEmpty) {
                this.showErrors(displayError);
                this.$cachedSelectors.invoiceManagerNotNecessary.addClass('show');
                Odigeo.trigger(this.widget.id + ':showErrorsResume', this.model.validationError, this.model.get('professional'));
            }
            return isEmpty;
        },

        showErrors: function() {
            var validationErrors = this.model.validationError;
            var opt = this.model.get('professional');
            Odigeo._.each(validationErrors, Odigeo._.bind(function(iter) {
                var validationField = this.$cachedSelectors[iter.name].closest('.validation_field');

                validationField.attr('data-state', iter.errorType);
                if (Odigeo.AB.isCssVariationMobile) {
                    validationField.addClass(iter.errorType);
                }
                this._changeError(validationField, false);
                if (Odigeo._.includes(['invoiceName', 'invoiceId'], iter.name)) {
                    validationField.attr('data-client', opt);
                }
                this.trackError(iter.name, iter.errorType, 'submit');
            }, this));
        },

        _checkField: function(initState, input) {
            var $elem = input.target ? $(input.target) : input;
            var name = $elem.attr('data-name');
            var validity = this.model.checkValidity(name);
            var state = 'valid';
            var $wrapper = this.$cachedSelectors[name].closest('.validation_field');
            if (Odigeo.AB.isCssVariationMobile) {
                $wrapper.removeClass('empty invalid');
            }
            var containsClass = !Odigeo._.isUndefined(input.relatedTarget) && !Odigeo._.isNull(input.relatedTarget) &&
                    Odigeo._.contains(input.relatedTarget.classList, 'payment_continue_button');
            if (validity === 'empty') {
                state = initState ? 'init' : 'empty';
            } else if (validity === false) {
                state = 'invalid';
            }

            this.$cachedSelectors.invoiceManagerNotNecessary.removeClass('show animate');
            $wrapper.attr('data-state', state);
            if (Odigeo.AB.isCssVariationMobile) {
                $wrapper.addClass(state);
            }
            this._changeError($wrapper, !containsClass);
            this._toggleFocused(false, $elem);
        },

        _toggleFocused: function(isFocused, input) {
            var $el;
            var $elem = input.target ? $(input.target) : input;
            var dataState = $elem.attr('data-state');
            var $bottomPlaceholder = $elem.siblings('.bottom_placeholder');
            if ($bottomPlaceholder.length > 0 && isFocused) {
                $bottomPlaceholder.fadeIn(250);
            } else if ($bottomPlaceholder.length > 0 && !isFocused) {
                $bottomPlaceholder.fadeOut(250);
            }
            $el = $elem.closest('.validation_field').toggleClass('focused', isFocused);
            $el.attr('data-state', isFocused ? 'init' : dataState);
        },

        cleanErrors: function() {
            var elems = this.$cachedSelectors.validationField.closest('.validation_field');
            Odigeo._.each(elems, function(elem) {
                var $elem = $(elem);
                if ($elem.attr('data-state') !== 'valid') {
                    $elem.attr('data-state', 'init');
                    if (Odigeo.AB.isCssVariationMobile) {
                        $elem.removeClass('empty invalid');
                    }
                }
            });
            Odigeo.trigger(this.widget.id + ':clearValidationErrors');

            this.$cachedSelectors.invoiceManagerNotNecessary.removeClass('show animate');
        },

        getInvoiceValidation: function(displayError) {
            var isInvoiceChecked = this.$cachedSelectors.invoiceDisplayOn.is(':checked');
            this.model.set('invoiceRequired', isInvoiceChecked);
            return isInvoiceChecked ? this.storageInvoice(displayError) : true;
        },

        _changeError: function(elem, track) {
            var $el = (elem instanceof $) ? elem : $(elem);
            if (Odigeo.AB.isCssVariationMobile) {
                $el.removeClass('empty invalid valid').addClass($el.attr('data-state'));
            }
            this.setErrorText($el,
                $el.attr('data-state') === 'empty' || $el.attr('data-state') === 'init' ? 'empty' : 'invalid', track);
        },

        setErrorText: function($el, formState, track) {
            var idLabel = Odigeo.AB.isCobaltDesktopForms ? '.prisma-input' : '.submit_field_focusable';
            var error = $el.find(idLabel).attr('data-' + (formState === 'empty' ? 'mandatory' : 'error'));
            $el.find('.wrong_label, .form-error')
                .text(error.trim());
            if ($el.attr('data-state') !== 'valid' && track) {
                this.trackError($el.find(idLabel).attr('data-name'), formState, 'inline');
            }
        },

        userLogged: function(data) {
            if (Odigeo._.isObject(data) && Odigeo._.isArray(data.traveller) && data.traveller.length > 0) {
                this.preFillLoggedUser(data.traveller[0]);
            }
        },
        getWrongChars: function(name, label) {
            var wrongCharacters = fieldUtils.giveWrongCharacters(this.$cachedSelectors[name]);
            return wrongCharacters ? label + '_char:' + wrongCharacters : label;
        },
        trackError: function(name, status, type) {
            var statusLabel = status === 'empty' ? '_missing_error' : '_invalid_error';
            var label = this.inputLabelCorrespondences[name] + '_' + type + statusLabel;
            if (type === 'submit') {
                label = this.getWrongChars(name, label);
            }
            trackingUtils.trackEvent('invoice_widget', label);
        },
    }),
    getInvoiceData: function() {
        var attributesCopy = $.extend(true, {}, this.model.attributes);
        attributesCopy.professional = attributesCopy.professional === 'B2B';
        this.view.addInvoiceIdCountry(attributesCopy);
        return {
            invoicemanager: attributesCopy,
        };
    },
    isInvoiceValid: function(displayError) {
        return this.view.getInvoiceValidation(displayError);
    },
    userLogged: function(data) {
        this.view.userLogged(data);
    },
}));
